if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}


const createSpanInBtn = () => {
	document.querySelectorAll('.btn').forEach((btn) => {
        for (var i = 0; i < 4; i++) {
            btn.innerHTML += `<span></span>`;
          }
	});
};

const removeSpanInBtn = () => {
	document.querySelectorAll('.btn').forEach((btn) => {
        
            btn.empty();
          
	});
};

(function(){

    const prevArrowHTML =
        `<button aria-label="prev image" class="slick-arrow slick-next prevHiddenClick">
        </button>`;
    const nextArrowtHTML =
        `<button aria-label="next image" class="slick-arrow slick-next">
            <span class="nextArrow"></span>
            <span class="prevArrow"></span>
            <svg width="100" height="100" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1">
            <path fill="#231f20" stroke="#fff" stroke-width="0.5px" transform="translate(33 27)"
             d="M.642 17.323a.663.663 0 0 1-.467-1.132l7.424-7.417L.175 1.357A.664.664 0 0 1 .173.42.661.661 0 0 1 1.11.419l7.894 7.886a.664.664 0 0 1 0 .938L1.109 17.13a.659.659 0 0 1-.467.194z"/>
            <circle vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" />
            <circle class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" />
            </svg>
        </button>`;

    const nextArrowWhiteHTML =
        `<button aria-label="next image" class="slick-arrow slick-next">
            <span>Next</span>
            <svg width="100" height="100" stroke="#fff" viewBox="0 0 72 72" preserveAspectRatio="none" fill="none" stroke="currentColor" stroke-width="1">
                <path fill="#fff" stroke="#fff" stroke-width="0.5px" transform="translate(33 27)"
                d="M.642 17.323a.663.663 0 0 1-.467-1.132l7.424-7.417L.175 1.357A.664.664 0 0 1 .173.42.661.661 0 0 1 1.11.419l7.894 7.886a.664.664 0 0 1 0 .938L1.109 17.13a.659.659 0 0 1-.467.194z"/>
                <circle stroke="#fff" vector-effect="non-scaling-stroke" cx="36" cy="36" r="35" />
                <circle stroke="#fff" class="hover" vector-effect="non-scaling-stroke" cx="36" cy="36" r="34" stroke-width="2" />
            </svg>
        </button>`;

    const slickOptions = {
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowtHTML
    };

    const slickOptionsWhite = {
        accessibility: true,
        prevArrow: prevArrowHTML,
        nextArrow: nextArrowWhiteHTML
    };
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

     // Slick Slider with current slide number
     $('.home-slider').each((i, el) => {
        let currentIndex = '01';

        $(el).on('init', (e, s)=> {
            if ( s.options.dots ) {
                $(s.options.appendDots).append(`<span class="slick-current_index">${currentIndex}</span>`);
            } else if ( s.options.arrows ) {
                $(s.options.appendArrows).prepend(`<span class="slick-current_index">${currentIndex}</span>`);
            }
        });

        $(el).on('beforeChange', (e, s, c, n)=> {
            currentIndex = (`0${(n+1)}`).slice(-2);
            if ( s.options.dots ) {
                $('.slick-current_index', s.options.appendDots).text(currentIndex);
            } else if ( s.options.arrows ) {
                $('.slick-current_index', s.options.appendArrows).text(currentIndex);
            }
        });

        $(el).slick();
    });



    $('.sym-slides').slick({
        accessibility: true
    });

    $('.sym-slides-slider').slick({
        accessibility: true,
        autoplay: false,
        autoplaySpeed: 5000,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        pauseOnDotsHover: false,
        nextArrow:slickOptions.nextArrow,
        prevArrow:slickOptions.prevArrow,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            }
          ]
        
    });

    $('.top-reasons-slides').slick({
        accessibility: true,
        arrows: false,
        dots: true,
        infinite: false,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
    });


    let $homeSlider = $('.home-slider');
    $homeSlider.slick({
        autoplaySpeed: 5000 
    });

    let $bar = $('.slider-progress__bar');
    $bar.addClass('active');
    $homeSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $bar.removeClass('active');
        setTimeout(function(){
            $bar.addClass('active');
        },50)
    });


    let ScrollDown = document.getElementsByClassName('js-scrolldown');
    if(ScrollDown.length > 0){
        ScrollDown[0].addEventListener('click', function(){
            animateto('intro');
        });
    }
  

    $('[data-fancybox]').fancybox({
        loop : true,
    });


    let screenHeight = $(window).height();
    $('#home .top-img figure, #home .top-img video').css("height", screenHeight - 100);

    $(window).resize(function(){
        screenHeight = $(window).height();
        $('#home .top-img figure, #home .top-img video').css("height", screenHeight -100);
    });

    // APPEND FRAME SPAN TO BTNs
	createSpanInBtn();

    // Weddings RFP form condition
    document.querySelector( "[name='choice_of_property']" ).addEventListener( "change", (e) => {
        let value = e.target.value
        if( value == "Kona Kai Resort" ){
             document.querySelector( "[name='number_of_guests']" ).max = 49
            $("[name='wedding_date']").datepicker( "destroy" )
            $("[name='wedding_date']").datepicker({ minDate: new Date('2023/06/01' ), maxDate: new Date('2023/12/31'), numberOfMonths: 1 })
        }else if( value == "Azul Del Mar" ){
            document.querySelector( "[name='number_of_guests']" ).max = 60
            $("[name='wedding_date']").datepicker( "destroy" )
            $("[name='wedding_date']").datepicker();
        }else{
             document.querySelector( "[name='number_of_guests']" ).max = 120
            $("[name='wedding_date']").datepicker( "destroy" )
            $("[name='wedding_date']").datepicker();
        }
    } )

})();